import request from '@/utils/request'

export function getEpms91C0(param) {
  let data = param
  return request({
    url: `/deliveryReport/epms91C0/getEpms91C0`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//getEpms91C0Xls
export function getEpms91C0Xls(param) {
  let data = param
  return request({
    url: `/deliveryReport/epms91C0/getEpms91C0Xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {

    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)

    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }

    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
    const blobURL = URL.createObjectURL(blob)

    const link = document.createElement('a');
    link.href = blobURL;
    link.download = `Pipe Pieces Warehouse Status.xls`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  })
}

